import React from 'react';

import { Switch, Route } from 'react-router-dom';
import { menuItemFilter, routeList, cerrarSesion } from '../../routes/routeList.js';
import NotFound from '../../pages/NotFound';
import SinAcceso from '../../pages/SinAcceso';
import { useGeneral } from '../../Context/GeneralContext';

// El flag del cliente (build-time) decide si la ruta existe; si está apagada la
// ruta ni se registra y cae en NotFound (comportamiento previo).
const isAllowed = (route) =>
    !Object.keys(menuItemFilter).includes(route.id) || menuItemFilter[route.id];

const MainView = () => {
    const { hasAccess } = useGeneral();

    // El rol decide qué se renderiza: si no tiene acceso, la URL directa muestra
    // 403 (SinAcceso) en lugar del componente real.
    const guard = (route) => (hasAccess(route.id) ? route.component : SinAcceso);

    return (
        <Switch>
            {routeList.filter(isAllowed).map((route) => {
                if (!route.children) {
                    return (
                        <Route exact path={route.path} key={route.id} component={guard(route)} />
                    );
                } else {
                    return route.children
                        .filter(isAllowed)
                        .map((subroute) => (
                            <Route
                                exact
                                path={subroute.path}
                                key={subroute.id}
                                component={guard(subroute)}
                            />
                        ));
                }
            })}
            {cerrarSesion.map((route) => {
                if (!route.children) {
                    return (
                        <Route exact path={route.path} key={route.id} component={route.component} />
                    );
                } else {
                    return route.children.map((subroute) => (
                        <Route
                            exact
                            path={subroute.path}
                            key={subroute.id}
                            component={subroute.component}
                        />
                    ));
                }
            })}
            <Route component={NotFound} />
        </Switch>
    );
};

export default MainView;
